import { Icon, IconProps } from 'design-system';

export const StepIcon = (props: IconProps) => {
  return (
    <Icon width='14px' height='13px' viewBox='0 0 14 13' fill='none' stroke='#B1B1B1' {...props}>
      <circle cx='7' cy='6.5' r='6.5' fill='inherit' stroke='inherit' />
    </Icon>
  );
};
